import { render, staticRenderFns } from "./GestcuotaDetailView.vue?vue&type=template&id=49956ce2"
import script from "./GestcuotaDetailView.vue?vue&type=script&lang=js"
export * from "./GestcuotaDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports